import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {StandingsCompetitionRulesDomainModel} from "./standings.competition-rules.domain-model";

export class StandingsCompetitionRulesViewModel extends BaseViewModel {
  domainModel: StandingsCompetitionRulesDomainModel;

  get title(): String {
    return this.domainModel.title;
  }

  get descriptions(): Array<String> {
    return this.domainModel.descriptions;
  }

}